import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import LoginView from "@/views/LoginView.vue";
import DataProcessView from "@/views/DataProcessView.vue";
import AccountManageView from "@/views/AccountManageView.vue";
import CompanyManageView from "@/views/CompanyManageView.vue";
import MobileManageView from "@/views/MobileManageView.vue";
import LoginRecordView from "@/views/LoginRecordView.vue";
import PasswordForgotView from "@/views/PasswordForgotView.vue";
import PasswordResetView from "@/views/PasswordResetView.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/login",
    name: "login",
    component: LoginView
  },
  {
    path: "/dataProcess",
    name: "dataProcess",
    component: DataProcessView
  },
  {
    path: "/accountManage",
    name: "accountManage",
    component: AccountManageView
  },
  {
    path: "/companyManage",
    name: "companyManage",
    component: CompanyManageView
  },
  {
    path: "/mobileManage",
    name: "mobileManage",
    component: MobileManageView
  },
  {
    path: "/loginRecord",
    name: "loginRecord",
    component: LoginRecordView
  },
  {
    path: "/passwordForgot",
    name: "passwordForgot",
    component: PasswordForgotView
  },
  {
    path: "/passwordReset",
    name: "passwordReset",
    component: PasswordResetView
  },
  {
    path: "/",
    redirect: "/login"
  },
  {
    path: "*",
    redirect: "/login"
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
